import { gql, useMutation } from '@apollo/client'
/**
 * @deprecated use useCommentActions instead
 */
export const DELETE_COMMENT = gql`
  mutation ($id: String!) {
    removeComment(id: $id) {
      id
      text
      campaign_id
    }
  }
`
/**
 * @deprecated use useCommentActions instead
 */
export const useDeleteComment = () => {
  const [mutate, { data, loading, error }] = useMutation(DELETE_COMMENT, {
    update(cache) {
      cache.modify({
        fields: {
          getGlobalizerFeedsByCampaignId() {},
          getFeedsByCampaignId() {},
          getFeeds() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
